'use client';
/**
 * @file     ThemeContext.tsx
 * @readme   ./README.md
 * @purpose  React context definition for ThemeContextValue (mode, setMode, toggleMode, theme); consumed by useAppTheme.
 */
import { createContext } from 'react';
import type { AppTheme, ThemeMode } from '@/core/types';

export type ThemeContextValue = {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
  toggleMode: () => void;
  theme: AppTheme;
};

export const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);
